export enum KeyCodes {
  ENTER = 13,
  ESCAPE = 27,
  LEFT = 37,
  UP = 38,
  RIGHT = 39,
  DOWN = 40
}
